import React from 'react';

interface IconProps extends React.SVGProps<SVGSVGElement> {
  fillColor?: string; // Accepts color values or 'currentColor'
}

const IntroIcon: React.FC<IconProps> = ({ fillColor, ...props }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18 5.5C18 5.22386 17.7761 5 17.5 5C17.2239 5 17 5.22386 17 5.5V16.5C17 16.7761 17.2239 17 17.5 17C17.7761 17 18 16.7761 18 16.5V5.5ZM20 10.5C20 10.2239 19.7761 10 19.5 10C19.2239 10 19 10.2239 19 10.5V16.5C19 16.7761 19.2239 17 19.5 17C19.7761 17 20 16.7761 20 16.5V10.5ZM15 8.5C15 8.22386 15.2239 8 15.5 8C15.7761 8 16 8.22386 16 8.5V16.5C16 16.7761 15.7761 17 15.5 17C15.2239 17 15 16.7761 15 16.5V8.5ZM14 10.5C14 10.2239 13.7761 10 13.5 10C13.2239 10 13 10.2239 13 10.5V16.5C13 16.7761 13.2239 17 13.5 17C13.7761 17 14 16.7761 14 16.5V10.5ZM11 11.5C11 11.2239 11.2239 11 11.5 11C11.7761 11 12 11.2239 12 11.5V16.5C12 16.7761 11.7761 17 11.5 17C11.2239 17 11 16.7761 11 16.5V11.5ZM10 12.5C10 12.2239 9.77614 12 9.5 12C9.22386 12 9 12.2239 9 12.5V16.5C9 16.7761 9.22386 17 9.5 17C9.77614 17 10 16.7761 10 16.5V12.5ZM7 13.5C7 13.2239 7.22386 13 7.5 13C7.77614 13 8 13.2239 8 13.5V16.5C8 16.7761 7.77614 17 7.5 17C7.22386 17 7 16.7761 7 16.5V13.5ZM6 14.5C6 14.2239 5.77614 14 5.5 14C5.22386 14 5 14.2239 5 14.5V16.5C5 16.7761 5.22386 17 5.5 17C5.77614 17 6 16.7761 6 16.5V14.5ZM3 15.5C3 15.2239 3.22386 15 3.5 15C3.77614 15 4 15.2239 4 15.5V16.5C4 16.7761 3.77614 17 3.5 17C3.22386 17 3 16.7761 3 16.5V15.5Z"
        fill={fillColor || '#48484B'}
      />
    </svg>
  );
};

export { IntroIcon };
